// NE oldu kadranı — NAV sparkline (inline SVG, recharts YOK).

import type { LotMarker } from "../data/mockSinyal";

interface Props {
  path: string;
  fillPath: string;
  markers: LotMarker[];
  ariaLabel?: string;
}

export default function NavSparkline({
  path,
  fillPath,
  markers,
  ariaLabel,
}: Props) {
  return (
    <div className="mt-2 -mx-1">
      <svg
        viewBox="0 0 200 80"
        className="w-full h-20 line-art"
        aria-label={ariaLabel ?? "NAV grafiği"}
      >
        <line
          x1="0"
          y1="40"
          x2="200"
          y2="40"
          stroke="#1f2632"
          strokeWidth="1"
          strokeDasharray="2 3"
        />
        <defs>
          <linearGradient id="navg" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#2dd4bf" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#2dd4bf" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d={path} fill="none" stroke="#2dd4bf" strokeWidth="2" />
        <path d={fillPath} fill="url(#navg)" stroke="none" />
        {markers.map((m, i) => (
          <circle
            key={i}
            cx={m.x}
            cy={m.y}
            r="3"
            fill="#0c0f16"
            stroke={m.highlight ? "#fb923c" : "#2dd4bf"}
            strokeWidth={m.highlight ? 1.8 : 1.5}
          >
            <title>{m.label}</title>
          </circle>
        ))}
      </svg>
    </div>
  );
}
